module.exports = __webpack_public_path__ + "img/upgradeHistory__succeed.938ce9fe.png";